import React from 'react'
import strip from 'striptags'
import { FormattedMessage } from 'react-intl'

const inputWrap = (next, e) => {
  if (e && e.target && next)
  next(strip(e.target.value))
}

export default ({
  onSubmit,
  onInput,
  placeholder,
  value,
  disableBtn = false,
  noAutoFocus = false,
  noEnter = false,
  disabled = false,
  children,
  btnTitle,
  type,
  classname,
  onClick,
  enSubmitTitle,
  hideInput = false,
  ...props
}) => {
  const Component = noEnter ? 'div' : 'form'

  return (
    <Component className='Form' action='.' onSubmit={onSubmit}>
      {!hideInput && (
        <input
          type={type ? type : 'text'}
          className={(type && type == 'Number') ? (classname ? 'Form__field Form__field-number ' + classname : 'Form__field Form__field-number ') : (classname ? classname : 'Form__field')}
          value={value || ''}
          placeholder={placeholder}
          onInput={disabled ? undefined : inputWrap.bind(this, onInput)}
          ref={el => { !noAutoFocus && ((el && el.focus) && el.focus()) }}
          {...props}
          key="inputKey"
          onClick={onClick ? onClick : undefined}
        />
      )}
      {children}
      {!disableBtn && <button type='submit' className='Button Button_white _submitForm' onClick={onSubmit}>{enSubmitTitle || <FormattedMessage id={btnTitle || 'form.send'} /> }</button>}
    </Component>
  )
}



// WEBPACK FOOTER //
// ./src/components/Form.jsx